export const PPSL_AUDIT_TYPES = [
	'manual_count_adjustment',
	'manual_price_adjustment',
	'manual_count_and_price_adjustment',
	'initial_min_quantity_adjustment',
	'min_quantity_adjustment',
	'max_quantity_adjustment',
	'shipped_to_work_order',
	'returned_from_work_order',
	'receive',
	'return',
	'transferred',
	'invoice_price_adjustment',
	'automated_zero_cost_adjustment',
	'delisted',
	'relisted',
];

export const getAuditFieldNameByKey = (key) => {
	const allNames = {
		maxQuantity: 'Max Quantity',
		minQuantity: 'Min Quantity',
		onHandQuantity: 'On Hand Quantity',
		transferred: 'Transferred',
		manual: 'Manual',
		purchase_order: 'Purchase Order',
		manual_count_adjustment: 'Manual count adjustment',
		manual_count_and_price_adjustment: 'Manual count and price adjustment',
		automated_zero_cost_adjustment: 'Automated zero cost adjustment',
		delisted: 'Delisted',
		relisted: 'Relisted',
		initial_min_quantity_adjustment: 'Initial min qty adjustment',
		min_quantity_adjustment: 'Min qty adjustment',
		max_quantity_adjustment: 'Max qty adjustment',
		shipped_to_work_order: 'Shipped to WO',
		returned_from_work_order: 'Returned from WO',
		receive: 'Received',
		[`return`]: 'Returned',
		invoice_price_adjustment: 'Invoice price adjustment',
		totalStockedPartsCost: 'Total stocked parts cost',
		received: 'Received',
		initial_disbursement: 'Initial Disbursement',
		disbursement: 'Disbursement',
		manual_price_adjustment: 'Manual price adjustment',
		burden_rate_change: 'Burden rate change',
		pr_created: 'PR Created',
		pr_updated: 'PR Updated',
		pr_status_changed: 'Status Changed',
		pr_deleted: 'PR Deleted',
		pr_tier_approved: 'Tier Approved',
		pr_tier_denied: 'Tier Denied',
		po_created: 'PO Created',
		po_updated: 'PO Updated',
		po_status_changed: 'Status Changed',
		po_deleted: 'PO Deleted',
		po_note_added: 'Note Added',
		po_emailed: 'PO Emailed',
		receipt_created: 'Receipt Created',
		receipt_updated: 'Receipt Updated',
		receipt_deleted: 'Receipt Deleted',
		line_item_added: 'Line Item Added',
		line_item_updated: 'Line Item Updated',
		line_item_removed: 'Line Item Removed',
		line_item_status_changed: 'Line Item Status Changed',
		line_item_quantity_updated: 'Quantity Updated',
		line_item_received_qty_updated: 'Received Qty Updated',
		line_item_cost_updated: 'Cost Updated',
		line_item_po_associated: 'PO Associated',
	};
	return allNames[key] || key;
};
